import { createFileRoute, notFound } from "@tanstack/react-router"
import Checkout from "@/pages/checkout"
import { CheckoutStepKey } from "@/lib/types/global"
import { sanitize } from "@/lib/utils/sanitize"

export const Route = createFileRoute("/$countryCode/checkout")({
  validateSearch: (search) => {
    let step = search.step === "delivery" ? CheckoutStepKey.PICKUP : search.step
    if (!Object.values(CheckoutStepKey).includes(step as CheckoutStepKey)) {
      step = CheckoutStepKey.ADDRESSES
    }
    return {
      step,
    }
  },
  loaderDeps: ({ search: { step } }) => {
    return {
      step,
    }
  },
  loader: async ({ params, context, deps }) => {
    const { countryCode } = params
    const { queryClient } = context
    const { step } = deps
    const { getRegion } = await import("@/lib/data/regions")

    const region = await queryClient.ensureQueryData({
      queryKey: ["region", countryCode],
      queryFn: () => getRegion({ country_code: countryCode }),
    })

    if (!region) {
      throw notFound()
    }

    return sanitize({
      region,
      countryCode,
      step,
    })
  },
  head: () => ({
    meta: [
      { title: "Checkout | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Checkout,
})
